// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Ayarlar',
  subtitle: 'Sistem ayarlarını yönetin',
  telegram: {
    title: 'Telegram Bildirimleri',
    enable: 'Telegram bildirimlerini aktif et',
    botToken: 'Telegram Bot Token *',
    botTokenPlaceholder: '123456789:ABCdefGHIjklMNOpqrsTUVwxyz',
    botTokenHint: 'BotFather\'dan aldığınız bot token\'ını girin',
    chatId: 'Telegram Chat ID *',
    chatIdPlaceholder: '123456789',
    chatIdHint: 'Bildirim almak istediğiniz chat ID\'yi girin (@userinfobot ile öğrenebilirsiniz)',
    sendTest: 'Test Bildirimi Gönder',
    save: 'Ayarları Kaydet',
    sending: 'Gönderiliyor...',
    saving: 'Kaydediliyor...',
    testNotification: 'Test Bildirimi',
    testMessage: 'Test Bildirimi - Telegram bildirimleri çalışıyor!',
    sendingTest: 'Telegram test mesajı gönderiliyor...',
    testSent: 'Test bildirimi başarıyla gönderildi!',
    botTokenRequired: 'Lütfen önce bot token ve chat ID girin',
    botTokenInvalid: 'Bot token geçersiz.',
    chatIdNotFound: 'Chat ID bulunamadı.',
    backendNotFound: 'Backend endpoint bulunamadı.',
    apiError: 'API yanıt hatası',
    corsError: 'Backend çalışmıyor.',
    instructions: 'Telegram Bot Oluşturma:',
    step1: 'Telegram\'da @BotFather ile konuşun',
    step2: '/newbot komutunu gönderin',
    step3: 'Bot adını ve kullanıcı adını belirleyin',
    step4: 'BotFather size bir token verecek',
    step5: 'Chat ID almak için @userinfobot ile konuşun',
    notificationInfo: 'Bildirim Gönderimi:',
    notificationInfo1: 'Sunucu offline olduğunda otomatik bildirim gönderilir',
    notificationInfo2: 'Bildirimler sadece online\'dan offline\'a geçişte gönderilir',
    notificationInfo3: 'Her 5 dakikada bir sunucu durumu kontrol edilir'
  },
  exchangeRates: {
    title: 'Döviz Kurları',
    autoFetch: 'Otomatik Çek',
    fetching: 'Çekiliyor...',
    info: 'Kur Bilgisi:',
    infoText: 'Kurlar TL baz alınarak hesaplanır.',
    usd: 'USD/TL Kur *',
    eur: 'EUR/TL Kur *',
    gbp: 'GBP/TL Kur *',
    gold: 'Gram Altın/TL Kur *',
    placeholder: 'Örn: 34.50',
    goldHint: 'Gram altın fiyatı manuel olarak güncellenmelidir',
    save: 'Kurları Kaydet',
    saveRates: 'Kurları Kaydet',
    fetchingRates: 'Kurlar çekiliyor...',
    ratesUpdated: 'Kurlar güncellendi',
    ratesFetchError: 'Kurlar çekilemedi.',
    goldFetchError: 'Altın fiyatı otomatik çekilemedi.',
    tcmbError: 'Kurlar çekilemedi'
  },
  googleCalendar: {
    title: 'Google Takvim Entegrasyonu',
    enable: 'Google Takvim entegrasyonunu aktif et',
    autoSync: 'Otomatik senkronizasyonu aktif et',
    syncInterval: 'Senkronizasyon Aralığı',
    interval1: 'Her 1 Saatte Bir',
    interval6: 'Her 6 Saatte Bir',
    interval12: 'Her 12 Saatte Bir',
    interval24: 'Her 24 Saatte Bir',
    interval168: 'Her Hafta',
    syncIntervalHint: 'Takvim otomatik olarak senkronize edilecektir.',
    save: 'Google Takvim Ayarlarını Kaydet',
    saveGoogleCalendarSettings: 'Google Takvim Ayarlarını Kaydet',
    usage: 'Google Takvim Kullanımı:',
    usageText: 'Takvim sayfasından ödeme takvimini Google Takvim\'e export edebilirsiniz.',
    usageHint: 'ICS dosyasını Google Takvim\'e import edebilirsiniz.',
    syncIntervalLabel: 'Senkronizasyon Aralığı (Saat)',
    interval1Hour: 'Her 1 Saatte Bir',
    interval6Hours: 'Her 6 Saatte Bir',
    interval12Hours: 'Her 12 Saatte Bir',
    interval24Hours: 'Her 24 Saatte Bir (Günlük)',
    intervalWeek: 'Her Hafta',
    syncIntervalHintText: 'Takvim belirtilen aralıklarla otomatik olarak Google Calendar\'a senkronize edilecektir.'
  },
  advanced: {
    title: 'İnce Ayarlar',
    warning: 'Uyarı:',
    warningText: 'Bu işlemler geri alınamaz.',
    clearCache: 'Çeviri Cache\'ini Temizle',
    clearCacheDesc: 'Dil çevirilerinin önbelleğini temizler.',
    clearCacheHint: 'Çeviri güncellemelerini görmek için cache\'i temizleyin.',
    clearCacheConfirm: 'Çeviri cache\'ini temizlemek istediğinizden emin misiniz?',
    clearCacheButton: 'Cache\'i Temizle',
    cacheCleared: 'Çeviri cache\'i temizlendi.',
    cacheClearError: 'Cache temizlenirken hata oluştu',
    deleteAllData: 'Tüm Verileri Sil',
    deleting: 'Siliniyor...',
    deleteConfirm: 'Tüm veriler silinecek. Emin misiniz?',
    deletingData: 'Veriler siliniyor...',
    dataDeleted: 'Tüm veriler başarıyla silindi',
    deleteError: 'Veriler silinirken hata oluştu',
    userNotFound: 'Kullanıcı bilgisi bulunamadı.',
    supabaseNotFound: 'Supabase bağlantısı bulunamadı',
    loadDemoData: 'Demo Veri Yükle',
    loading: 'Yükleniyor...',
    loadDemoConfirm: 'Demo veri yüklemek istiyor musunuz?',
    loadingDemo: 'Demo veriler yükleniyor...',
    demoLoaded: 'Demo veriler başarıyla yüklendi!',
    demoLoadError: 'Demo veriler yüklenirken hata oluştu',
    demoProgress: 'Demo veriler yükleniyor...'
  },
  fetchError: 'Ayarlar yüklenemedi',
  saveSuccess: 'Ayarlar başarıyla kaydedildi',
  saveError: 'Ayarlar kaydedilemedi',
  telegramNotifications: 'Telegram Bildirimleri',
  telegramBotCreation: 'Telegram Bot Oluşturma:',
  telegramStep1: 'Telegram\'da',
  telegramStep2: 'ile konuşun',
  telegramStep3: 'Bot adını ve kullanıcı adını belirleyin',
  telegramStep4: 'BotFather size bir',
  telegramStep5: 'Chat ID almak için',
  enableTelegram: 'Telegram bildirimlerini aktif et',
  telegramBotTokenLabel: 'Telegram Bot Token *',
  telegramChatIdLabel: 'Telegram Chat ID *',
  telegramBotTokenHintText: 'BotFather\'dan aldığınız bot token\'ını girin',
  telegramChatIdHintText: 'Bildirim almak istediğiniz chat ID\'yi girin (@userinfobot ile öğrenebilirsiniz)',
  sendTestNotification: 'Test Bildirimi Gönder',
  saveSettings: 'Ayarları Kaydet',
  sendingTest: 'Gönderiliyor...',
  savingSettings: 'Kaydediliyor...',
  testNotificationSent: 'Test bildirimi başarıyla gönderildi!',
  pleaseEnterTokenAndChatId: 'Lütfen önce bot token ve chat ID girin',
  botTokenInvalid: 'Bot token geçersiz.',
  chatIdNotFound: 'Chat ID bulunamadı.',
  backendNotFound: 'Backend endpoint bulunamadı.',
  apiError: 'API yanıt hatası',
  corsError: 'Backend çalışmıyor.',
  sendingTelegramTest: 'Telegram test mesajı gönderiliyor...',
  exchangeRatesTitle: 'Döviz Kurları',
  autoFetchRates: 'Kurları Otomatik Çek',
  fetchingRates: 'Çekiliyor...',
  rateInfo: 'Kur Bilgisi:',
  rateInfoText: 'Kurlar TL baz alınarak hesaplanır.',
  usdTlRate: 'USD/TL Kur *',
  eurTlRate: 'EUR/TL Kur *',
  gbpTlRate: 'GBP/TL Kur *',
  gramGoldTlRate: 'Gram Altın/TL Kur *',
  ratePlaceholder: 'Örn: 34.50',
  goldPriceHint: 'Gram altın fiyatı manuel olarak güncellenmelidir',
  saveRates: 'Kurları Kaydet',
  fetchingRatesText: 'Kurlar çekiliyor...',
  ratesUpdated: 'Kurlar güncellendi',
  ratesCouldNotBeFetched: 'Kurlar çekilemedi.',
  goldPriceCouldNotBeFetched: 'Altın fiyatı otomatik çekilemedi.',
  ratesCouldNotBeFetchedTCMB: 'Kurlar çekilemedi',
  fetchRatesAutomatically: 'Kurları Otomatik Çek',
  googleCalendarTitle: 'Google Takvim Entegrasyonu',
  enableGoogleCalendar: 'Google Takvim entegrasyonunu aktif et',
  enableAutoSync: 'Otomatik senkronizasyonu aktif et',
  syncIntervalLabel: 'Senkronizasyon Aralığı (Saat)',
  every1Hour: 'Her 1 Saatte Bir',
  every6Hours: 'Her 6 Saatte Bir',
  every12Hours: 'Her 12 Saatte Bir',
  every24Hours: 'Her 24 Saatte Bir (Günlük)',
  everyWeek: 'Her Hafta',
  syncIntervalHintText: 'Takvim otomatik olarak belirtilen aralıklarla Google Calendar\'a senkronize edilecektir.',
  saveGoogleCalendarSettings: 'Google Takvim Ayarlarını Kaydet',
  googleCalendarUsage: 'Google Takvim Kullanımı:',
  googleCalendarUsageText: 'Takvim sayfasından ödeme takvimini Google Takvim\'e export edebilirsiniz.',
  googleCalendarUsageHint: 'ICS dosyasını Google Takvim\'e import edebilirsiniz.',
  advancedSettingsTitle: 'İnce Ayarlar',
  warningTitle: 'Uyarı:',
  warningText: 'Bu işlemler geri alınamaz.',
  clearTranslationCache: 'Çeviri Cache\'ini Temizle',
  clearTranslationCacheDesc: 'Dil çevirilerinin önbelleğini temizler.',
  clearTranslationCacheHint: 'Çeviri güncellemelerini görmek için cache\'i temizleyin.',
  clearCacheButton: 'Cache\'i Temizle',
  translationCacheCleared: 'Çeviri cache\'i temizlendi.',
  errorClearingCache: 'Cache temizlenirken hata oluştu',
  deleteAllDataButton: 'Tüm Verileri Sil',
  deletingDataText: 'Siliniyor...',
  deleteAllDataConfirm: 'Tüm veriler silinecek. Emin misiniz?',
  deletingDataText2: 'Veriler siliniyor...',
  allDataDeleted: 'Tüm veriler başarıyla silindi',
  errorDeletingData: 'Veriler silinirken hata oluştu',
  loadDemoDataButton: 'Demo Veri Yükle',
  loadingDemoDataText: 'Yükleniyor...',
  loadDemoDataConfirm: 'Demo veri yüklemek istiyor musunuz?',
  loadingDemoDataText2: 'Demo veriler yükleniyor...',
  demoDataLoaded: 'Demo veriler başarıyla yüklendi!',
  errorLoadingDemoData: 'Demo veriler yüklenirken hata oluştu',
  loadingDemoProgress: 'Demo veriler yükleniyor...',
  settingsCouldNotBeLoaded: 'Ayarlar yüklenemedi',
  settingsSavedSuccessfully: 'Ayarlar başarıyla kaydedildi',
  settingsCouldNotBeSaved: 'Ayarlar kaydedilemedi',
  settingsLoadError: 'Ayarlar yüklenemedi: ',
  settingsSaveError: 'Ayarlar kaydedilemedi: ',
  ratesFetchedSuccessfully: 'Kurlar güncellendi: ',
  ratesCouldNotBeFetchedText: 'Kurlar çekilemedi. Lütfen manuel olarak girin.',
  ratesFetchErrorText: 'Kurlar çekilemedi: ',
  goldPriceCouldNotBeFetchedAuto: 'Altın fiyatı otomatik çekilemedi. Lütfen manuel olarak girin.',
  telegramTestSent: 'Test bildirimi başarıyla gönderildi! Telegram\'ınızı kontrol edin.',
  telegramTestError: 'Test bildirimi gönderilemedi',
  telegramBotTokenRequired: 'Lütfen önce bot token ve chat ID girin',
  telegramBotTokenInvalidText: 'Bot token geçersiz. Lütfen token\'ı kontrol edin.',
  telegramChatIdNotFoundText: 'Chat ID bulunamadı. Lütfen chat ID\'yi kontrol edin.',
  telegramBackendNotFound: 'Backend endpoint bulunamadı. Lütfen backend\'in çalıştığından emin olun.',
  telegramApiError: 'API yanıt hatası',
  telegramCorsError: 'Backend çalışmıyor. Lütfen backend\'i başlatın (npm run server:dev) veya http://localhost:5001 adresinin erişilebilir olduğundan emin olun.',
  userNotFoundText: 'Kullanıcı bilgisi bulunamadı. Lütfen tekrar giriş yapın.',
  supabaseNotFoundText: 'Supabase bağlantısı bulunamadı',
  allDataDeletedConfirm: 'Tüm veriler silinecek (açık olan kullanıcı hariç). Emin misiniz?',
  deletingDataText3: 'Veriler siliniyor...',
  allDataDeletedSuccessfully: 'Tüm veriler başarıyla silindi (açık olan kullanıcı hariç)',
  errorDeletingDataText: 'Veriler silinirken hata oluştu: ',
  demoDataLoadConfirm: 'Demo verileri yüklemek istediğinizden emin misiniz? Mevcut veriler üzerine yazılabilir.',
  loadingDemoDataText4: 'Demo veriler yükleniyor...',
  demoDataLoadedSuccessfully: 'Demo veriler başarıyla yüklendi!',
  errorLoadingDemoDataText: 'Demo veriler yüklenirken hata oluştu: '
};
